import { FunctionComponent } from "react";
import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import { ConfirmTransferScreenProps } from "../useConfirmTransfer";
import ScrollableContainer from "../../../layout/scrollable-container";
import Container from "../../../layout/container";
import Footer from "../../../components/footer";
import styled from "styled-components";
import { COLOR_DEEP_FOREST, COLOR_TEXT_GRAY } from "../../../styles/globalStylesVariables";
import DestinationAccount, { AccountType } from "../../../class/destinationAccount";
import { UNEXPECTED_ERROR_MESSAGE } from "../../../typings";
import { TitleLarge } from "../../../components/font";
import { Button } from "@manifesthhqinc/ui-library";
import HeadingContainer from "../../../layout/heading-container";

const StyledTransferDetailsContainer = styled.div`
  margin-top: 24px;
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  border-radius: 6px;
  background: #ededed;
  padding: 21px 23px 23px 23px;
  overflow: hidden;

  .transfer-from {
    overflow-y: auto;
    margin-bottom: 24px;
  }

  ul {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    list-style-type: none;
    gap: 8px;
  }

  li {
    color: ${COLOR_TEXT_GRAY};
  }

  .title {
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
    color: ${COLOR_DEEP_FOREST};
    margin-bottom: 10px;
  }
`;

const transformDestinationDetails = (data: DestinationAccount): string => {
  if (data.destinationAccountType === AccountType.employerSponsored) {
    return data.planName && data.providerName
      ? `${data.planName} - ${data.providerName}`
      : `${data.planSponsor} ${data.providerName ? `- ${data.providerName}` : ""}`;
  }
  return `IRA - ${data.providerName}`;
};
const ConfirmTransferDetails: FunctionComponent<ConfirmTransferScreenProps> = (props: ConfirmTransferScreenProps) => {
  const { transferDetails, onClickContinue, setShowError } = props;

  if (!transferDetails.destinationAccount || transferDetails.transferId === -1) {
    setShowError(UNEXPECTED_ERROR_MESSAGE);
    throw Error(UNEXPECTED_ERROR_MESSAGE);
  }

  return (
    <TransitionWrapper>
      <ScrollableContainer name="confirm-transfer-screen-initiateTransfer">
        <Container>
          <HeadingContainer paneVariant="form" withProgressBar>
            <TitleLarge $textAlign="left">Confirm your details</TitleLarge>
          </HeadingContainer>
          <StyledTransferDetailsContainer>
            <div className="transfer-from">
              <p className="title">Transfer from:</p>
              <ul>
                {transferDetails.sourceAccounts.map((sourceAccount) => (
                  <li key={sourceAccount.planSponsor}>{sourceAccount.planSponsor}</li>
                ))}
              </ul>
            </div>

            <div className="transfer-to">
              <p className="title">Transfer to:</p>
              <p>{transformDestinationDetails(transferDetails.destinationAccount)}</p>
            </div>
          </StyledTransferDetailsContainer>
        </Container>
      </ScrollableContainer>
      <Footer>
        <p className="disclaimer-text no-max-width text-center">
          Next, review your personal details to verify your identity for your transfer.
        </p>
        <Button name="continue" onClick={onClickContinue} size="large">
          Continue
        </Button>
      </Footer>
    </TransitionWrapper>
  );
};

export default ConfirmTransferDetails;
